import { base64 } from '@/utils/index'
const mutations = {
  /**
   * ========================================================
   * ************   公共部分   ************
   * ========================================================
   */

  // 储存顶部导航文字
  setNavigateTitle(state, navigateTitle) {
    state.navigateTitle = navigateTitle
  },
  // 储存底部tab状态
  setTabAction(state, tabAcion) {
    state.tabAcion = tabAcion
  },
  // 储存用户信息
  setUserInfo(state, info) {
    let I = base64.encode(JSON.stringify(info));
    state.userInfo = info
    localStorage.setItem('I', I)
  },
  //储存用户角色信息
  // setUserRole(state, role) {
  //   let R = base64.encode(JSON.stringify(role));
  //   state.userRole = role
  //   localStorage.setItem('R', R)
  // },
  setCallName(state, info) {
    state.CallName = info
    localStorage.setItem('C', info)
  },
  // 控制menu显示
  setMenuShow(state, menuShow) {
    state.menuShow = menuShow
  },
  // 储存menulist
  setMenuList(state, menuList) {
    state.menuList = menuList
  },
  // 储存menulist中选中的
  setCurrentMenu(state, currentMenu) {
    state.currentMenu = currentMenu
  },
  // 存款是否新版本
  setIsNewDeposit(state, isNewDeposit) {
    state.isNewDeposit = isNewDeposit
  }
  /**
   * ========================================================
   * ************   account-info   ************
   * ========================================================
   */

  // 储存提交银行信息
  // setBackInfo(state, bank) {
  //   state.bankInfo = bank
  // }
}

export default mutations


// WEBPACK FOOTER //
// ./src/store/mutations.js